export default {
  async redirectWhenResponseIsSlow (fetchDataPromise, startTime) {
    await Promise.race([fetchDataPromise,
      new Promise((resolve, reject) => {
          const timeout = process.env.APP_REDIRECT_TIME;
          const elapsedTime = Date.now() - startTime;
          if (elapsedTime >= timeout) {
              reject(new Error('Timeout occurred'));
          } else {
             resolve();
          }
      })
    ]);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/helper.js